import React, { Dispatch, FC, SetStateAction } from "react";
import { useOnChangeChildDispatch } from "utils/OnChange";
import { SearchWidgetTextThemeBuilder } from "./TextThemeBuilder";
import { ThemeBuilderSection } from "../WidgetThemeBuilder/ThemeBuilderSection";
import { SearchWidgetBubbleSectionThemeBuilder } from "./BubbleSectionThemeBuilder";
import { SearchWidgetBubblesOthersTheme } from "./SearchWidgetTypes";

export interface SearchWidgetBubbleThemeBuilderProps {
    readonly label?: string;
    readonly theme: SearchWidgetBubblesOthersTheme | undefined;
    readonly defaultTheme: SearchWidgetBubblesOthersTheme | undefined;
    readonly onChange: Dispatch<SetStateAction<SearchWidgetBubblesOthersTheme>>;
}

const EMPTY_THEME: SearchWidgetBubblesOthersTheme = {};

export const SearchWidgetBubbleThemeBuilder: FC<SearchWidgetBubbleThemeBuilderProps> = props => {
    const theme: SearchWidgetBubblesOthersTheme = props.theme ?? EMPTY_THEME;
    const defaultTheme: SearchWidgetBubblesOthersTheme = props.defaultTheme ?? EMPTY_THEME;

    const { onChange } = props;

    const handleBubbleChange = useOnChangeChildDispatch("bubble", onChange);
    const handleTextChange = useOnChangeChildDispatch("text", onChange);

    return (
        <ThemeBuilderSection heading={props.label ?? "Bubbles Style"}>
            <SearchWidgetBubbleSectionThemeBuilder key="bubbleTheme" theme={theme.bubble} defaultTheme={defaultTheme.bubble} onChange={handleBubbleChange} />
            <SearchWidgetTextThemeBuilder key="text" theme={theme.text} defaultTheme={defaultTheme.text} onChange={handleTextChange} />
        </ThemeBuilderSection>
    );
};